import axios from '@/request/http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块

const examinGoodsSorting = {
  //获取验货单列表信息（复核单）
  getExamineMainList (params) {
    return axios.post('/order/examineGoodsSorting/getExamineMainList', qs.stringify(params))
  },
  //获取验货单商品列表信息（复核单）
  getExamineGoodsList (params) {
    return axios.post('/order/examineGoodsSorting/getExamineGoodsList', qs.stringify(params))
  },
  //验收验货单商品信息（复核单）
  updateExamineGoodsNum (params) {
    return axios.post('/order/examineGoodsSorting/updateExamineGoodsNum', qs.stringify(params))
  },
  //提交验货单信息（复核单）
  submitExamineMain (params) {
    return axios.post('/order/examineGoodsSorting/submitExamineMain', qs.stringify(params))
  },
  //获取验货单详情信息（复核单）
  getExamineMainDetailList (params) {
    return axios.post('/order/examineGoodsSorting/getExamineMainDetailList', qs.stringify(params))
  },
  //一键验收验货单商品信息（复核单）
  batchUpdateExamineGoodsNum (params) {
    return axios.post('/order/examineGoodsSorting/batchUpdateExamineGoodsNum', qs.stringify(params))
  },
  //根据箱码获取验货单
  getExamineSheetByContainerNo (params) {
    return axios.post('/order/examineGoodsSorting/getExamineSheetByContainerNo', qs.stringify(params))
  },
  //根据验货单获取箱码列表
  getContainerNoByExamineSheet (params) {
    return axios.post('/order/examineGoodsSorting/getContainerNoByExamineSheet', qs.stringify(params))
  },
}
export default examinGoodsSorting



// WEBPACK FOOTER //
// ./src/request/api/order/examinGoodsSorting.js